<template>
  <v-dialog v-model="dialog" lazy max-width="500">
    <v-btn class="gtm-send-code" slot="activator" round color="primary" data-ffid="send-code-btn">{{buttonTitle}}</v-btn>
    <v-card class="elevation-12">
      <v-container fluid ma-0 pa-2>
        <v-layout row>
          <v-flex class="text-xs-left pa-2 pt-3 title font-weight-bold">
            {{$t('sendCode.howToSend')}}
          </v-flex>
          <v-flex class="pt-0 text-xs-right" >
            <v-icon size="32px" @click="dialog = false" style="opacity:.5;" data-ffid="close-popup">close</v-icon>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container fluid ma-0 pa-0>
        <v-layout column>
          <v-container pb-3 pt-1 mb-0>
            <v-layout row class="py-1 align-center justify-start">
              <v-flex shrink class="pr-2">
                <v-icon color="#212121">email</v-icon>
              </v-flex>
              <v-flex grow class="text-sm-left">
                <strong>{{$t('sendCode.emailPrompt')}}</strong>
              </v-flex>
            </v-layout>
            <v-text-field outline single-line validate-on-blur
              v-model="email"
              :placeholder="$t('sendCode.emailHelp')"
              :rules="[rules.email]" @input="successValidate()"
              data-ffid="email-input"></v-text-field>
            <v-layout row class="py-1 align-center justify-start">
              <v-flex shrink class="pr-2">
                <v-icon color="#212121">textsms</v-icon>
              </v-flex>
              <v-flex class="pt-0 text-xs-left body-2">
                <strong>{{$t('sendCode.textSmsPrompt')}}</strong>
              </v-flex>
            </v-layout>
            <v-text-field outline single-line validate-on-blur
              mask="phone" v-model="phone"
              :placeholder="$t('sendCode.textSmsHelp')"
              :rules="[rules.phone]" @input="successValidate()"
              data-ffid="phone-input"
              ></v-text-field>
            <v-btn :disabled="!okToSend" block round color="primary" @click="doSendCode();" data-ffid="send-code-btn">{{$t('sendCode.sendCodeShort')}}</v-btn>
          </v-container>
          <div class="divider-flat"></div>
          <v-container pt-3 class="body-1 muted-text">
            {{$t('sendCode.limitationsOfUse')}} {{$t('sendCode.limitationsOfUse2')}}
          </v-container>
        </v-layout>
      </v-container>
    </v-card>
    <!-- error dialog -->
    <v-dialog v-model="errorMsg.length" persistent width='85vw'>
      <v-card>
        <v-card-title>
        </v-card-title>
        <v-card-text>
          <span style="font-size:150%">{{errorMsg}}</span>
        </v-card-text>
        <v-card-actions>
          <v-btn round color="primary" @click="errorMsg = ''">{{$t('common.ok')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>

<script>

var self

export default {
  name: 'SendCodeScreen',
  props: {
    code: {},
    messagingURL: {},
    affiliateID: {},
    appKey: {},
    buttonTitle: {},
    authToken: {}
  },
  data () {
    return {
      dialog: false,
      codeDestEmail: 0, // -1 is no good, 0 is none entered, 1 is good
      codeDestText: 0, // same
      okToSend: false,
      email: '',
      phone: '',
      errorMsg: '',
      isEmail: false,
      isCanada: false,
      rules: {
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          if (!value) { // happens beforeMounted, and when field is blank
            this.codeDestEmail = 0
            this.email = ''
            return true
          }
          let result = pattern.test(value)
          this.codeDestEmail = value.length === 0 ? 0 : (result ? 1 : -1)
          return !value.length || result || window.i18n.t('sendCode.invalidEmail')
        },
        phone: value => {
          if (!value) {
            this.codeDestText = 0
            this.phone = ''
            return true
          }
          let result = value.length === 10
          this.codeDestText = value.length === 0 ? 0 : (result ? 1 : -1)
          return !value.length || result || window.i18n.t('sendCode.invalidPhone')
        }
      }
    }
  },
  mounted () {
    self = this
    this.isCanada = window.location.hostname.includes('.ca')
  },
  methods: {
    doSendCode () {
      this.sendMessage(this.email, this.phone)

      // close this dialog from error handler and/or from success condition,
      // not from here, because message sending concludes with success/fail callbacks
    },
    successValidate () {
      let success = true
      let emailValidation = this.rules.email(this.email)
      let phoneValidation = this.rules.phone(this.phone)
      if (typeof emailValidation === 'string' || emailValidation instanceof String) emailValidation = false
      if (typeof phoneValidation === 'string' || phoneValidation instanceof String) phoneValidation = false
      if (this.email.length && !emailValidation) success = false
      if (this.phone.length && !phoneValidation) success = false
      if (this.email.length === 0 && this.phone.length === 0) success = false
      this.okToSend = success
    },
    sendMessageToEndpoint (appKey, affiliateID, authToken, deliverTo, countryCode, languageCode) {
      // let context = this

      let messagingSendEndpoint = this.messagingURL // 'https://is.fujifilmapi.com/rest/v1/messaging/'
      let dataBlob2 = { 'AffiliateID': affiliateID, 'AuthToken': authToken, 'TemplateType': 'PhotoTransferPostUpload', 'DeliverTo': deliverTo, 'CountryCode': countryCode, 'LanguageCode': languageCode }
      let messagingSendResult = jQuery.ajax({
        url: messagingSendEndpoint,
        type: 'POST',
        data: JSON.stringify(dataBlob2),
        processData: false,
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Fujifilm ApiKey=' + appKey
        }
      })
      messagingSendResult.done(function (file2, status2, xhr2) {
        // context.errorMsg = 'Message sent successfully'
        self.dialog = false // close SendCodeScreen
        self.$emit('messageSent', true)
        self.email = ''
        self.phone = ''
      })
      messagingSendResult.fail(doErrorMessage)

      function doErrorMessage () {
        self.dialog = true
        self.errorMsg = window.i18n.t('sendCode.errorOccurred')
        if (self.codeDestEmail > 0) {
          self.errorMsg += window.i18n.t('sendCode.email')
        } else {
          self.errorMsg += window.i18n.t('sendCode.textSms')
        }
      }
    },
    sendMessage (email, phone) {
      // this.isEmail = deliverTo.indexOf('@') !== -1

      // "this" works in here, but not in messagingAuthResult.done, its a different context, so use locals
      let appKey = this.appKey
      let affiliateID = this.affiliateID
      let countryCode = 'US'
      let languageCode = this.$i18n.locale.toUpperCase()

      if (this.isCanada) {
        countryCode = 'CA'
      }

      let sendCode = ''
      if (self.codeDestEmail > 0) {
        sendCode += 'Email'
        self.sendMessageToEndpoint(appKey, affiliateID, self.authToken, email, countryCode, languageCode)
      }

      if (self.codeDestText > 0) {
        if (sendCode.length) {
          sendCode += ' | '
        }
        sendCode += 'SMS'
        self.sendMessageToEndpoint(appKey, affiliateID, self.authToken, phone, countryCode, languageCode)
      }

      window.dataLayer.push({ sendCode })
      window.dataLayer.push({ event: 'send_code_button_click' })
    }
  }
}
</script>
